// src/components/Dashboard.js
import React from 'react';

const Dashboard = ({ purchases }) => {
  // محاسبه آمار از داده‌های واقعی
  const totalPurchases = purchases.reduce((sum, p) => sum + p.totalAmount, 0);
  
  // فرضی برای فروش (فعلاً نمونه)
  const totalSales = 12500000;
  const netProfit = totalSales - totalPurchases;
  
  const stats = [
    { id: 'totalSales', title: 'مجموع فروش', value: totalSales, icon: '💰', color: '#10b981' },
    { id: 'totalPurchases', title: 'مجموع خرید', value: totalPurchases, icon: '🛒', color: '#f59e0b' },
    { id: 'netProfit', title: 'سود خالص', value: netProfit, icon: '📈', color: '#3b82f6' },
    { id: 'transactionCount', title: 'تعداد تراکنش‌ها', value: purchases.length, icon: '📊', color: '#8b5cf6' }
  ];

  // آخرین 10 خرید
  const recentPurchases = [...purchases]
    .sort((a, b) => b.id - a.id)
    .slice(0, 10)
    .map(p => ({
      id: p.id,
      supplier: p.supplier,
      amount: p.totalAmount,
      date: p.date
    }));

  // آخرین فروش‌ها (هنوز نمونه)
  const recentSales = [
    { id: 1, customer: 'شرکت الف', amount: '۲,۵۰۰,۰۰۰', date: '۱۴۰۲/۱۱/۱۰' },
    { id: 2, customer: 'فروشگاه ب', amount: '۱,۸۰۰,۰۰۰', date: '۱۴۰۲/۱۱/۰۹' },
    { id: 3, customer: 'بازار الکترونیک', amount: '۳,۲۰۰,۰۰۰', date: '۱۴۰۲/۱۱/۰۸' }
  ];

  const formatPrice = (price) => {
    return price.toLocaleString('fa-IR');
  };

  return (
    <div className="dashboard">
      <div className="stats-grid">
        {stats.map((stat) => (
          <div key={stat.id} className="stat-card">
            <div className="stat-icon" style={{ backgroundColor: stat.color + '20', color: stat.color }}>
              {stat.icon}
            </div>
            <div className="stat-info">
              <h3>{stat.title}</h3>
              <p>{formatPrice(stat.value)} تومان</p>
            </div>
          </div>
        ))}
      </div>

      <div className="tables-section">
        <div className="table-container">
          <div className="table-header">
            <span className="table-title">آخرین فروش‌ها</span>
            <span className="more-link">مشاهده همه</span>
          </div>
          <table className="data-table">
            <thead>
              <tr>
                <th>مشتری</th>
                <th>مبلغ (تومان)</th>
                <th>تاریخ</th>
              </tr>
            </thead>
            <tbody>
              {recentSales.map((sale) => (
                <tr key={sale.id}>
                  <td>{sale.customer}</td>
                  <td>{sale.amount}</td>
                  <td>{sale.date}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="table-container">
          <div className="table-header">
            <span className="table-title">آخرین خریدها</span>
            <span className="more-link">مشاهده همه</span>
          </div>
          <table className="data-table">
            <thead>
              <tr>
                <th>تامین‌کننده</th>
                <th>مبلغ (تومان)</th>
                <th>تاریخ</th>
              </tr>
            </thead>
            <tbody>
              {recentPurchases.map((purchase) => (
                <tr key={purchase.id}>
                  <td>{purchase.supplier}</td>
                  <td>{formatPrice(purchase.amount)}</td>
                  <td>{purchase.date}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;